import { Button, Item, ItemHeader, ItemTitle } from '@ibsys/kit';
import { FileTextIcon, PlusIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type ChildItem = {
  id: number;
  name: string;
};

type BehaviorFactorSubfactorsProps = {
  subfactors: ChildItem[];
  onAddSubfactor: () => void;
  onSelectSubfactor: (id: number) => void;
  disabled?: boolean;
};

export const BehaviorFactorSubfactors: FC<BehaviorFactorSubfactorsProps> = ({
  subfactors,
  onAddSubfactor,
  onSelectSubfactor,
  disabled,
}) => {
  const { t } = useTranslation('behaviorFactors');

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-foreground">{t('subfactors')}</h3>
        {!disabled && (
          <Button variant="outline" size="sm" icon={<PlusIcon className="size-4" />} onClick={onAddSubfactor}>
            {t('addSubfactor')}
          </Button>
        )}
      </div>

      {subfactors.length === 0 ? (
        <div className="text-sm text-muted-foreground">{t('noSubfactors')}</div>
      ) : (
        <ul className="flex flex-col gap-2">
          {subfactors.map((child) => (
            <li key={child.id} onClick={() => onSelectSubfactor(child.id)}>
              <Item variant="outline" className="hover:bg-muted cursor-pointer">
                <ItemHeader>
                  <div className="flex items-center gap-2">
                    <FileTextIcon className="size-4 shrink-0 text-muted-foreground" />
                    <ItemTitle className="text-sm text-primary hover:underline">{child.name}</ItemTitle>
                  </div>
                </ItemHeader>
              </Item>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
